import * as localizer from './constants/constants.en.js';
export { localizer };



// WEBPACK FOOTER //
// ./src/utils/localizer/index.js